//@flow
import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';
import {useForm} from 'react-hook-form';
import CustomTextField from '../../../../elements/CustomTextField/CustomTextField';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {useBlogCategoriesAction} from '../../utils/blog-category';

const useStyle = makeStyles(theme => ({
  root: {
    maxWidth: '600px',
    margin: '0 auto',
    padding: '2rem 0',
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    textAlign: 'center',
    paddingBottom: '1rem',
    borderBottom: `1px solid ${colors.grey300}`,
    marginBottom: '.75rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.75rem',
  },
}));

const CATEGORY_FORM_FIELDS = {
  name: 'name',
};

type Props = {
  onSubmitSuccess: () => void,
  onSubmitError: () => void,
};

export default function CategoryForm(props: Props) {
  const {onSubmitSuccess, onSubmitError} = props;

  const classes = useStyle();

  const {register, handleSubmit, errors} = useForm();

  const {createCategory} = useBlogCategoriesAction();

  const onSubmit = data => {
    createCategory({name: data[CATEGORY_FORM_FIELDS.name]})
      .then(() => {
        onSubmitSuccess();
      })
      .catch(() => {
        onSubmitError();
      });
  };

  return (
    <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
      <Typography className={classes.title}>
        Nueva Categoría del Blog
      </Typography>

      <CustomTextField
        name={CATEGORY_FORM_FIELDS.name}
        inputRef={register({
          required: 'Este campo es requerido',
          pattern: {
            value: /^\S.*$/,
            message: 'Formato incorrecto',
          },
        })}
        label="Nombre de la categoría"
        fullWidth
        error={!!errors[CATEGORY_FORM_FIELDS.name]}
        helperText={
          errors[CATEGORY_FORM_FIELDS.name] &&
          errors[CATEGORY_FORM_FIELDS.name].message
        }
      />

      <CustomButton variant="contained" type="submit">
        Agregar Categoría
      </CustomButton>
    </form>
  );
}
